import axios from '../utils/axios';
export const login = async (initData) => axios.post('auth', { init_data: initData });
export const getMe = async () => axios.get('user/getUser');
